import React from 'react';
import ResetPasswordForm from '../../components/resetPassword/ResetPasswordForm';

const ResetPasswordPage = () => {
  return (
    <div className="reset-password-container">
        <ResetPasswordForm/>
    </div>
  )
}

export default ResetPasswordPage